import { render, staticRenderFns } from "./ModalAreaEdit.vue?vue&type=template&id=d4cbca8a&scoped=true"
import script from "./ModalAreaEdit.vue?vue&type=script&lang=js"
export * from "./ModalAreaEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalAreaEdit.vue?vue&type=style&index=0&id=d4cbca8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4cbca8a",
  null
  
)

export default component.exports